import callApi, { BaseResponse, BaseResponseDto, BaseResponsePagedDto } from "./baseRequest"

const route = 'notice';
export interface Notice {
    id: string,
    titlePt: string,
    titleEs: string,
    titleEn: string,
    bodyPt: string,
    bodyEs: string,
    bodyEn: string,
    author?: string,
    modifiedBy?: string,
    initialDate?: Date,
    finalDate?: Date,
    createdAt?: Date,
    modifiedAt?: Date,
    enabled: boolean,
    purchaseGroup: Number,
    country: string
};

export type NoticePost = Pick<Notice, 'titlePt' | 'titleEn' | 'titleEs' | 'bodyPt' | 'bodyEn' | 'bodyEs' | 'initialDate' | 'finalDate' | 'author' | 'country' | 'purchaseGroup'>;
export type NoticePut = Pick<Notice, 'titlePt' | 'id' | 'titleEn' | 'titleEs' | 'bodyPt' | 'bodyEn' | 'bodyEs' | 'initialDate' | 'finalDate' | 'author' | 'country' | 'purchaseGroup' | 'enabled'>;

export function getEmptyNotice(): Notice {
    return {
        id: ``,
        titlePt: ``,
        titleEs: ``,
        titleEn: ``,
        bodyPt: ``,
        bodyEs: ``,
        bodyEn: ``,
        author: ``,
        modifiedBy: ``,
        initialDate: undefined,
        finalDate: undefined,
        createdAt: undefined,
        modifiedAt: undefined,
        enabled: true,
        purchaseGroup: 0,
        country: ``
    }
}

export function getNotices(take: number, skip: number, search?: string, country?: string, initialDate?: string, finalDate?: string, purchaseGroup?: Number):Promise<BaseResponsePagedDto<Notice[]>> {
    const result: BaseResponsePagedDto<Notice[]> = {
        data: [],
        success: false,
        error: '',
        totalItems: 0,
        totalPages: 0,
        currentTake: take
    };

    const response = callApi('GET', `${route}/get-all/?take=${take}&skip=${skip}&search=${search}&country=${country}&finalDate=${finalDate}&initialDate=${initialDate}&purchaseGroup=${purchaseGroup}&isEnabled=${true}`)
    .then(resp => {
        if (resp?.data?.length > 0 ?? false) {
            result.data = resp?.data;               
            result.totalPages = resp.totalPages;
            result.totalItems = resp.totalItems;
            result.success = true;
        }
        else {
            result.error = 'Erro ao buscar os Informativos';
        }

        return result;
    })
    .catch(err => {
        return result;
    })

    return response;
}

export function createNotice(notice: NoticePost): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        success: false,
        data: null,
    };
    const response = callApi('POST', `${route}/create`, notice).then(response => {
            result.success = true;
            if (response.data) {
                result.success = true;
                result.data = response.data
            }
            return result;
        }).catch(err => {
            result.error = err.error;

            return result;
        });

    return response;
}

export function updateNotice(notice: NoticePut, id: string): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        success: false,
        data: null,
    };

    const response = callApi('PUT', `${route}/update/${id}`, notice)
        .then(response => {
            result.success = true;
            if (response.data) {
                result.success = true;
                result.data = response.data
            }
            return result;
        })
        .catch(err => {
            result.error = err.error;
            return result;
        });
    return response;
}

export function getNoticeById(id: string):Promise<BaseResponseDto<Notice>> {
    const result: BaseResponseDto<Notice> = {
        data: getEmptyNotice(),
        success: false,
        error: '',
    };

    const response = callApi('GET', `${route}/get-notice/${id}`)
    .then(resp => {
        if (resp?.data ?? false) {
            result.data = resp?.data;               
            result.success = true;
        }
        else {
            result.error = 'Erro ao buscar o Informativo';
        }

        return result;
    })
    .catch(err => {
        result.error = err;
        return result;
    })

    return response;
}